export default __webpack_public_path__ + "static/DEATH_GIRL_HALLOWEEN_PLACEHOLDER_GIF-53bec7066953ce46962e13094f3ac72c.gif";